// extracted by mini-css-extract-plugin
export var cardContainer = "_on-0";
export var cardHeader = "_on-2";
export var collapsedState = "_on-3";
export var dragHandle = "_on-5";
export var dragHandleIcon = "_on-6";
export var dragging = "_on-1";
export var titleArea = "_on-4";